export default     {
    path: 'internationalization',
    name: 'internationalization',
    component: () => import(/* webpackChunkName: "internationalization" */ '@/views/admin/Internationalization/index.vue'),
    children:[
        {
            path: 'text-settings',
            name: 'interLkb',
            component: () => import(/* webpackChunkName: "textSettings" */ '@/views/admin/Internationalization/interlkb.vue'),
        },
    ]
};
